module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/mailinglists/bravenet_mailinglists_works_everywhere.png";